import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Icon from '@mdi/react';
import { mdiViewDashboardOutline, mdiViewDashboardEditOutline } from '@mdi/js';
import AppHeader from '../../components/AppHeader';
import '../Common.css';
import '../Dashboard.css';
import '../header.css';

/**
 * TimetablePortal Page - Timetable Management Landing Page
 *
 * Central hub for class timetable and schedule functions
 */
const TimetablePortal = () => {
    const navigate = useNavigate();

    return (
        <div className="dashboard-container org-console">
            <AppHeader />

            {/* Main Content */}
            <div className="dashboard-main">
                <div className="dashboard-content-wrapper" style={{ maxWidth: '800px' }}>
                    {/* Portal Header Card */}
                    <div className="portal-header-card">
                        <div className="portal-header-title-row">
                            <button
                                onClick={() => navigate('/dashboard')}
                                className="back-nav-btn"
                            >
                                ← Dashboard
                            </button>
                            <h1 className="portal-header-title">
                                Timetable Portal
                            </h1>
                        </div>

                        <p className="portal-header-subtitle">
                            Upload and manage class timetables
                        </p>

                        <div className="portal-metrics">
                            <div className="portal-metric-item">
                                <span className="portal-metric-value">5</span>
                                <span className="portal-metric-label">Active Classes</span>
                            </div>
                            <div className="portal-metric-item">
                                <span className="portal-metric-value">8</span>
                                <span className="portal-metric-label">This Week</span>
                            </div>
                            <div className="portal-metric-item">
                                <span className="portal-metric-value">2 days ago</span>
                                <span className="portal-metric-label">Last Updated</span>
                            </div>
                        </div>
                    </div>

                    {/* Function Cards Grid */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2, 1fr)',
                        gap: '20px'
                    }}>
                        {/* Upload Timetables Card */}
                        <Link
                            to="/timetables/create"
                            className="content-card nav-card"
                            style={{ padding: '30px 24px' }}
                        >
                            <div className="module-card-header">
                                <h3>Upload Timetables</h3>
                                <Icon path={mdiViewDashboardOutline} size={1.1} color="#451f78" />
                            </div>
                            <p className="module-card-subtitle">
                                Upload timetable images for your dance classes
                            </p>
                        </Link>

                        {/* Manage Timetables Card */}
                        <Link
                            to="/timetables/manage"
                            className="content-card nav-card"
                            style={{ padding: '30px 24px' }}
                        >
                            <div className="module-card-header">
                                <h3>Manage Timetables</h3>
                                <Icon path={mdiViewDashboardEditOutline} size={1.1} color="#451f78" />
                            </div>
                            <p className="module-card-subtitle">
                                Edit existing schedules and handle class cancellations
                            </p>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TimetablePortal;
